import { render, staticRenderFns } from "./CountdownTimer.vue?vue&type=template&id=067c32b2&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=ts"
export * from "./CountdownTimer.vue?vue&type=script&lang=ts"
import style0 from "./CountdownTimer.vue?vue&type=style&index=0&id=067c32b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c32b2",
  null
  
)

export default component.exports